import * as React from 'react';
import styled from 'styled-components';
import { LineDivider } from '@doltech/ui/lib/figma/Divider/LineDivider';
import { verticalSpace } from '@doltech/utils/lib/css-style';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { GrammarCardBlog } from '../../home-page/components/GrammarCardBlog';
import { formatDate } from '@doltech/utils/lib/date';
import { DAY_MONTH_NAME_FORMAT } from '@doltech/utils/lib/constants';
import { GrammarTopicTypeContent } from '@doltech/domains/grammar/lib/shared/utils/constants';
import {
  getFinalUrlGrammar,
} from '../../shared/utils';
import { GrammarTemplateTypeEnum } from '../../shared/constants';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { useGetAuthInfo } from '@doltech/core/lib/auth/withGlobalUserAuthInfo';

const Container = styled.div`
  max-width: 500px;
  padding: 0 16px;
  margin: 0 auto;
  ${verticalSpace(24)};

  ${fromScreen(768)} {
    ${verticalSpace(32)};
    max-width: 100%;
    padding: 0;
    margin: 0;
  }
`;

const WithLine = styled.div`
  ${verticalSpace(24)}
  ${fromScreen(768)} {
    ${verticalSpace(32)}
  }
`;

interface GrammarAuthorBlogListProps {
  data?: any[];
}

export const GrammarAuthorBlogList = ({ data }: GrammarAuthorBlogListProps) => {
  const { isLoggedIn } = useGetAuthInfo();

  return (
    <Container>
      {data?.map((item, index) => {
        if (item?.templateTypeId === GrammarTemplateTypeEnum.BLOG_GRAMMAR_THEORY) {
          const {
            dol,
            name,
            lastModifiedAt,
            description,
            grammarTopic,
            status,
            url: theoryUrl,
            unListed = false,
          } = item || {};
          if (!isLoggedIn && unListed) {
            return null;
          }
          return (
            <WithLine key={index}>
              {index !== 0 && <LineDivider color={colorsV2.neutral20} space={0}/>}
              <GrammarCardBlog
                status={status}
                title={dol?.title || dol?.tocTitle || name}
                subRightText="Lý thuyết"
                subLeftText={formatDate(lastModifiedAt, DAY_MONTH_NAME_FORMAT)}
                description={dol?.description || description}
                topicUrl={grammarTopic?.imageTopicUrl}
                topicName={GrammarTopicTypeContent[grammarTopic?.topicId]}
                detailUrl={getFinalUrlGrammar(theoryUrl)}
                isLackOfUrl={!theoryUrl}
                type="theory"
                unListed={unListed}
              />
            </WithLine>
          );
        }
        const {
          dol,
          name,
          lastModifiedAt,
          description,
          grammarTopic,
          status,
          url: exerciseUrl,
          unListed = false,
        } = item || {};
        if (!isLoggedIn && unListed) {
          return null;
        }
        return (
          <WithLine key={index}>
            {index !== 0 && <LineDivider color={colorsV2.neutral20} space={0}/>}
            <GrammarCardBlog
              status={status}
              title={dol?.title || dol?.tocTitle || name}
              subRightText="Bài tập"
              subLeftText={lastModifiedAt ? formatDate(lastModifiedAt, DAY_MONTH_NAME_FORMAT) : '-'}
              description={dol?.description || description}
              topicUrl={grammarTopic?.imageTopicUrl}
              topicName={GrammarTopicTypeContent[grammarTopic?.topicId]}
              detailUrl={getFinalUrlGrammar(exerciseUrl)}
              isLackOfUrl={!exerciseUrl}
              type="exercise"
              unListed={unListed}
            />
          </WithLine>
        );
      })}
    </Container>
  );
};
